/* eslint-disable react-hooks/rules-of-hooks */
import { useContext, useEffect } from 'react'
import { useDatabase as useReactFireDatabase } from 'reactfire'
import firebaseContext from '../contexts/firebase/context'

const useDatabase = () => {
  const { addSdk, activeSDK } = useContext(firebaseContext)
  useEffect(() => {
    if (typeof window !== 'undefined') {
      addSdk('database')
    }
  }, [])
  return activeSDK.includes('database') && useReactFireDatabase()
}

export default useDatabase
